import {createUseStyles} from 'react-jss';
import Spacing from '../../style-helper/Spacing';

export default createUseStyles({
  collectionButtonLabel: {
    marginBottom: Spacing.half,
    marginTop: Spacing.quad,
    fontWeight: props => props.theme.inputLabelFontWeight,
  },
  collectionContent: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: props => props.theme.button.tab.fontWeight,
  },
  spinnerWrapper: {
    position: 'absolute',
    zIndex: 99,
    left: 0,
    right: 0,
    background: 'rgba(#999, 0.1)',
    textAlign: 'center',
  },
  icon: {
    width: '1.4em',
    height: '1.4em',
    marginRight: 6,
    marginLeft: 0,
    color: '#000',
  },
  pencilIcon: {
    width: 16,
    height: 16,
  },
  hasNoSelectedCollectionPointError: {
    marginTop: Spacing.single,
  },
});
